var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.daysToDeadline <= 3 ? _vm.dueAtFormatted : null }),expression:"{ content: daysToDeadline <= 3 ? dueAtFormatted : null }"}],class:{ fade: !_vm.dueAt, 'text--error': _vm.daysToDeadline <= 3 }},[_vm._v(_vm._s(_vm.dueAt))])
}
var staticRenderFns = []

export { render, staticRenderFns }